import { useState } from 'react';
import { motion } from 'framer-motion';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_q4fvkmh', 'template_4lmjiel', e.target, 'g929dTo4sMeR35Upt')
      .then((result) => {
          setStatus('Message Sent Successfully!');
          setFormData({ name: '', email: '', message: '' });
      }, (error) => {
          setStatus('Failed to send message. Please try again.');
      });
  };

  return (
    <section id="contact" className="py-20 mx-auto max-w-2xl px-6 relative">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3/4 h-3/4 bg-cyan-500/10 rounded-full blur-[100px] pointer-events-none"></div>

      <div className="text-center mb-10 relative z-10">
        <h2 className="font-display text-4xl font-bold text-white tracking-wide">
          Get In Touch
        </h2>
      </div>

      <motion.form 
        className="ui-card p-8 md:p-10 flex flex-col gap-5 relative z-10"
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        onSubmit={handleSubmit}
      >
        <div>
          <input 
            type="text" 
            name="name"
            placeholder="Your Name" 
            value={formData.name}
            onChange={handleChange}
            className="w-full bg-slate-950/50 border border-slate-700/50 rounded-full px-6 py-3 text-sm text-slate-200 placeholder:text-slate-500 focus:outline-none focus:border-cyan-400/50 focus:ring-1 focus:ring-cyan-400/50 transition-all"
            required 
          />
        </div>

        <div>
          <input 
            type="email" 
            name="email"
            placeholder="Your Email" 
            value={formData.email}
            onChange={handleChange}
            className="w-full bg-slate-950/50 border border-slate-700/50 rounded-full px-6 py-3 text-sm text-slate-200 placeholder:text-slate-500 focus:outline-none focus:border-cyan-400/50 focus:ring-1 focus:ring-cyan-400/50 transition-all"
            required 
          />
        </div>

        <div>
          <textarea 
            name="message"
            rows="5" 
            placeholder="Your Message" 
            value={formData.message}
            onChange={handleChange}
            className="w-full bg-slate-950/50 border border-slate-700/50 rounded-2xl px-6 py-4 text-sm text-slate-200 placeholder:text-slate-500 focus:outline-none focus:border-cyan-400/50 focus:ring-1 focus:ring-cyan-400/50 transition-all resize-none"
            required 
          ></textarea>
        </div>

        <button 
          type="submit" 
          className="mt-4 self-center px-8 py-3 rounded-full bg-gradient-to-r from-cyan-400 to-blue-500 text-white text-sm font-bold tracking-wide shadow-[0_0_20px_rgba(34,211,238,0.4)] hover:shadow-[0_0_35px_rgba(34,211,238,0.6)] hover:-translate-y-1 transition-all duration-300"
        >
          Send Message
        </button>

        {status && (
          <p className="text-center text-sm font-semibold mt-4 text-cyan-400">
            {status}
          </p>
        )}
      </motion.form>
    </section>
  );
};

export default Contact;